"use client";

import { c as _c } from "react/compiler-runtime";
import { Plus, X } from "lucide-react";
import { LanguageSwitcher } from "@/components/language-switcher";
import { ModelSelector } from "@/components/model-selector";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { SidebarTrigger } from "@/components/ui/sidebar";
import { Switch } from "@/components/ui/switch";
import { useI18n } from "@llmgateway/i18n/react";
import type { ApiModel, ApiProvider } from "@/lib/fetch-models";
interface ImageHeaderProps {
  models: ApiModel[];
  providers: ApiProvider[];
  selectedModels: string[];
  onModelChange: (index: number, model: string) => void;
  onAddModel: () => void;
  onRemoveModel: (index: number) => void;
  comparisonMode: boolean;
  onComparisonModeChange: (enabled: boolean) => void;
  hideCompare?: boolean;
}
export function ImageHeader(t0) {
  const $ = _c(21);
  const {
    models,
    providers,
    selectedModels,
    onModelChange,
    onAddModel,
    onRemoveModel,
    comparisonMode,
    onComparisonModeChange,
    hideCompare: t1
  } = t0;
  const hideCompare = t1 === undefined ? false : t1;
  const {
    t
  } = useI18n();
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SidebarTrigger />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== comparisonMode || $[2] !== models || $[3] !== onAddModel || $[4] !== onModelChange || $[5] !== onRemoveModel || $[6] !== providers || $[7] !== selectedModels || $[8] !== t) {
    t3 = <div className="flex min-w-0 flex-1 items-center gap-3">{t2}{comparisonMode ? <div className="flex min-w-0 flex-1 items-center gap-2 overflow-x-auto">{selectedModels.map((model, index) => <div key={index} className="flex items-center gap-1 shrink-0"><div className="w-[200px] min-w-[200px]"><ModelSelector models={models} providers={providers} value={model} onValueChange={v => onModelChange(index, v)} placeholder={t("modelSelector.selectModel")} mode="image" /></div>{selectedModels.length > 1 && <Button variant="ghost" size="icon" className="h-7 w-7 shrink-0" onClick={() => onRemoveModel(index)}><X className="h-3.5 w-3.5" /></Button>}</div>)}{selectedModels.length < 3 && <Button variant="outline" size="sm" className="shrink-0" onClick={onAddModel}><Plus className="h-3.5 w-3.5 mr-1" />{t("common.add")}</Button>}</div> : <div className="flex w-full min-w-0 max-w-[360px] items-center gap-2 sm:max-w-[420px]"><ModelSelector models={models} providers={providers} value={selectedModels[0] ?? ""} onValueChange={v_0 => onModelChange(0, v_0)} placeholder={t("modelSelector.selectImageModel")} mode="image" /></div>}</div>;
    $[1] = comparisonMode;
    $[2] = models;
    $[3] = onAddModel;
    $[4] = onModelChange;
    $[5] = onRemoveModel;
    $[6] = providers;
    $[7] = selectedModels;
    $[8] = t;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <LanguageSwitcher className="hidden sm:flex" />;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== comparisonMode || $[12] !== hideCompare || $[13] !== onComparisonModeChange || $[14] !== t) {
    t5 = (!hideCompare || comparisonMode) && <div className="hidden items-center gap-2 md:flex">{hideCompare ? <span className="text-muted-foreground text-xs">{t("playground.comparisonMode")}</span> : <><Label htmlFor="comparison-mode-img" className="text-muted-foreground text-xs">{t("playground.comparisonMode")}</Label><Switch id="comparison-mode-img" checked={comparisonMode} onCheckedChange={onComparisonModeChange} /></>}</div>;
    $[11] = comparisonMode;
    $[12] = hideCompare;
    $[13] = onComparisonModeChange;
    $[14] = t;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t5) {
    t6 = <div className="ml-3 flex items-center gap-3">{t4}{t5}</div>;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t3 || $[19] !== t6) {
    t7 = <header className="bg-background flex items-center border-b p-4">{t3}{t6}</header>;
    $[18] = t3;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
}